/* src/app/shared/components/new-tab/new-tab.component.scss */
/*# sourceMappingURL=new-tab.component.css.map */
